import { apiNa } from "@/redworks/api/index";

const TERMS_API = "/v1/terms";


function $getActiveTermsList() {
    return apiNa.get(`${TERMS_API}`);
  }
  
  function $getActiveTerms(termsCode) {
    return apiNa.get(`${TERMS_API}/${termsCode}`);
  }

  export{
    $getActiveTerms,
    $getActiveTermsList,
  }